import { useDispatch } from "react-redux";
import { clearConfirmTypeModal, clearTypeOfStatus, clearUserId } from "../../features/gms-state-and-modal/modal-slice";
import { getErrorMessage } from "../../utils/get-error-message.utils";
import { useToastify } from "../../library/toastify/toast-provider";
import { useDeactivateUserMutation, useResetPasswordUserMutation } from "../../api/it/account/account-api";
import { useModalAccess } from "../../components/global/modal/use-modal-access";
import { useAuthDataState } from "../data-state/use-auth-data-state";

export const useUserAction = () => {

    const { showToastNotify } = useToastify(); 
    const dispatch = useDispatch()
    const { typeOfStatus, currentUserId: currentId } = useModalAccess()
    const { userId } = useAuthDataState()
    const [resetPasswordUser, { isLoading: isLoadingResetPasswordUser }] = useResetPasswordUserMutation();
    const [deactivateUser, { isLoading: isLoadingDeactivateUser }] = useDeactivateUserMutation();

    const handleCancel = () => {
        dispatch(clearTypeOfStatus());
        dispatch(clearConfirmTypeModal());
        dispatch(clearUserId());
    }

    const handleResetPassword = async () => {
        if(!currentId) return;
        if(userId === currentId) {
            showToastNotify("You cannot view your own profile.", 'warning');
            return;
        }
        try {
            const result = await resetPasswordUser({ userId: currentId }).unwrap();
            showToastNotify(`${result.message}`, 'success');
            dispatch(clearTypeOfStatus());
            dispatch(clearConfirmTypeModal());
        } catch (error) {
            const errorMessage = getErrorMessage(error);
            showToastNotify(errorMessage, 'error');
        }
    };

    const handleDeactivateUser = async () => {
        if(!currentId || !typeOfStatus) return
        try {
            const result = await deactivateUser({ userId: currentId, action: typeOfStatus }).unwrap();
            showToastNotify(`${result.message}`, 'success');
            dispatch(clearTypeOfStatus());
            dispatch(clearConfirmTypeModal());
        } catch (error) {
            const errorMessage = getErrorMessage(error);
            showToastNotify(errorMessage, 'error');
        }
    };

    return {
        handleResetPassword,
        handleDeactivateUser,
        isLoadingResetPasswordUser,
        isLoadingDeactivateUser,
        handleCancel,
    }
}